import { Components, Theme } from '@mui/material';

const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    ChipProps: {
      size: 'small',
      sx: (theme) => ({
        '& .MuiChip-label': {
          color: theme.typography.h6.color,
          fontWeight: theme.typography.fontWeightMedium,
        },
      }),
    },
  },
  styleOverrides: {
    popper: {
      zIndex: 2010,
    },
    paper: ({ theme }) => ({
      border: `1px solid ${theme.palette.grey[300]}`,
      marginTop: theme.spacing(theme.spacingSizes.xs),
    }),
    listbox: {
      padding: 0,
    },
    option: ({ theme }) => ({
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightMedium,
    }),
    noOptions: ({ theme }) => ({
      fontSize: theme.fontSizes.regular,
    }),
  },
};

export default MuiAutocomplete;
